import React from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import TimePicker from "react-bootstrap-time-picker";
import Select from "react-select";
import moment from "moment";
import { timeFromInt } from "time-number";
import { TIME_OPTIONS } from "../../components/contstants/AppointmentConstants";

/**
 * Card content for slotting weekend/weekday students into time slots.
 * Only renders when activeKey === "slotStudents".
 */
export default function SlotStudentsCard({
  activeKey,
  selectedDay,
  selectedWeekday,
  dayOfExam,
  selectedLocation,
  unsavedManuallyAddedStudents,
  selectedTimeSlot,
  slotTime,
  startTime,
  endTime,
  unslotedMembers,
  slots,
  loading,

  // render helpers passed from parent
  locationSelector,
  noDateSelectedPrompt,

  // callbacks
  onAddNewStudents,
  onSlotDurationChange,
  onStartTimeChange,
  onEndTimeChange,
  onGenerateSlots,
  onStudentPick,
  onSlotMove,
  onSlotClear,
  onSlotDelete,
  onSlotSave,
}) {
  if (activeKey !== "slotStudents") {
    return null;
  }

  if (!selectedDay) {
    return noDateSelectedPrompt;
  }

  if (selectedLocation.length === 0) {
    return (
      <div>
        You have not selected a road test location. Please select a
        location first!
        <div className="padLeft">
          {selectedLocation.length > 0 ? (
            <div>Now viewing lessons for: {selectedLocation}</div>
          ) : null}
          {locationSelector}
        </div>
      </div>
    );
  }

  if (selectedLocation.includes("RMV Site")) {
    return (
      <div>
        RMV Road Test Sites do not have slots. The email will be
        sent out requesting that folks show up at 7:45 am on the
        date.
      </div>
    );
  }

  return (
    <div>
      <div>
        {unsavedManuallyAddedStudents.length > 0 ? (
          <div>
            <div>
              Warning. You have unsaved manually added
              students from earlier. Please save these
              students first.
            </div>
            <Button
              className="padLeft"
              variant="success"
              onClick={onAddNewStudents}
            >
              Save New Students
            </Button>
          </div>
        ) : null}
        <div>Select Duration of Each Slot</div>
        <Select
          value={selectedTimeSlot}
          onChange={(data) => onSlotDurationChange(data)}
          options={TIME_OPTIONS}
        />
        <br></br>

        <div>
          Generate/View Slots for{" "}
          {moment(dayOfExam).format("dddd, MMMM Do YYYY")}
        </div>
        <br></br>
        <Row>
          <Col>
            <TimePicker
              start="5:00"
              end="21:00"
              step={slotTime}
              onChange={onStartTimeChange}
              value={startTime}
            />
          </Col>
          <Col sm={1}>to</Col>
          <Col>
            <TimePicker
              start={timeFromInt(
                parseInt(startTime) + 60 * slotTime,
              )}
              end="21:00"
              step={slotTime}
              onChange={onEndTimeChange}
              value={endTime}
            />
          </Col>
        </Row>
        <br></br>
        <Button className="padLeft" onClick={onGenerateSlots}>
          Generate Slots
        </Button>
        {unslotedMembers.length > 0 ? (
          <div>
            There{" "}
            {unslotedMembers.length === 1 ? (
              <span>is</span>
            ) : (
              <span>are</span>
            )}{" "}
            {unslotedMembers.length} student
            {unslotedMembers.length === 1 ? null : "s"}{" "}
            remaining.{" "}
          </div>
        ) : (
          <div>Looks like all students have been slotted.</div>
        )}
      </div>

      <div>
        <hr></hr>

        {slots.length === 0 ? (
          <div>
            There are currently no slots. Please generate some
            to start filling in students.
          </div>
        ) : null}
        <br></br>
        <Table striped bordered hover responsive size="sm">
          <thead>
            <tr className="d-flex">
              <th className="col-1">#</th>
              <th className="col-1">Time</th>
              <th className="col-6">Students</th>
              <th className="col-4">Actions</th>
            </tr>
          </thead>
          <tbody>
            {slots.map((x, index) => {
              return (
                <tr key={x.slotName} className="d-flex">
                  <td className="col-1">{index + 1}</td>
                  <td className="col-1">{x.slotName}</td>
                  <td className="col-6">
                    <Select
                      value={{
                        label: slots[index].person,
                        value: slots[index].value,
                      }}
                      onChange={(data) => onStudentPick(data, index)}
                      options={unslotedMembers.map(function (x) {
                        return {
                          value: x,
                          label: x.fName + " " + x.lName,
                        };
                      })}
                    />
                  </td>
                  <td className="col-4">
                    <Button
                      variant="secondary"
                      disabled={index === 0}
                      onClick={() => onSlotMove(index, "up")}
                      size="sm"
                    >
                      Move Up
                    </Button>
                    <Button
                      variant="secondary"
                      disabled={index === slots.length - 1}
                      onClick={() => onSlotMove(index, "down")}
                      size="sm"
                    >
                      Move Down
                    </Button>
                    <Button
                      variant="secondary"
                      disabled={slots[index].person.length === 0}
                      onClick={() => onSlotClear(index)}
                      size="sm"
                    >
                      Clear Slot
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => onSlotDelete(index)}
                      size="sm"
                    >
                      Delete Slot
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Button
          variant="primary"
          className="padLeft"
          disabled={loading || selectedWeekday.length === 0}
          onClick={onSlotSave}
        >
          {" "}
          Save Slots{" "}
        </Button>

        {selectedWeekday ? null : (
          <div>Please Confirm Day of Week for Exam First</div>
        )}
      </div>
    </div>
  );
}
